module.exports = __webpack_public_path__ + "static/media/wheels.4aa72be8.jpg";